<template>
  <form data-id="export-data-form" @submit.prevent.stop="exportData">
    <Card :no-card="noCard">
      <!-- TODO change no card class -->
      <template #header>
        <CardHeader
          data-test="export-data"
          icon="export"
          :title="'Export data'"
        />
      </template>
      <div>
        <Spinner v-if="loading" />
        <div v-else-if="downloadLink">
          <!-- download link-->
          <Btn
            tag="a"
            size="sm"
            :href="downloadLink"
            target="_blank"
            :variant="Variant.secondary"
            rel="noopener noreferrer"
          >
            {{ 'Download' }} {{ selectedExportType }}
          </Btn>
          <Btn tag="button" :variant="Variant.secondary" @click="reset">
            {{ 'Back' }}
          </Btn>
        </div>
        <FormGrouping v-else>
          <FormGroup
            :label="'Data type'"
            :notes="'What type of data to export'"
            required
          >
            <FormSelect
              v-model="selectedExportType"
              :options="exportTypes"
              name="exportType"
              required
            />
          </FormGroup>
          <FormGroup
            :label="'Output format'"
            :notes="'File format to create'"
            required
          >
            <FormSelect
              v-model="selectedOutputFormat"
              :options="outputFormats"
              name="outputFormats"
              required
            />
          </FormGroup>
        </FormGrouping>
      </div>
      <template #footer>
        <SubmitForm
          v-if="!downloadLink"
          :loading="loading"
          size="sm"
          :text="'Download data'"
        />
      </template>
    </Card>
  </form>
</template>
<script setup lang="ts">
import {
  ExportEntitiesExportTypeEnum,
  ExportOptionsOutputFormatEnum,
  GetExportLinkExportTypeEnum,
} from '@mailslurp/admin-sdk';
import SubmitForm from '../../components/SubmitForm.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import Spinner from '../../components/Spinner.vue';
import CardHeader from '../../components/CardHeader.vue';
import { loadFetch } from '../../lib/services/helpers';
import { Variant } from '../../store/types';
import { onMounted, ref } from 'vue';
import FormGrouping from '../../components/form/FormGrouping.vue';
import Btn from '../../components/form/Btn.vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import Card from '../../components/tw/Card.vue';
import FormSelect from '../../components/form/FormSelect.vue';
import { computed } from '#imports';

const store3 = useStore3();

withDefaults(defineProps<{ noCard?: boolean }>(), {
  noCard: false,
});

const loading = ref<boolean>(false);
// output formats
const selectedOutputFormat = ref<ExportOptionsOutputFormatEnum>(
  ExportOptionsOutputFormatEnum.DEFAULT,
);

const outputFormats = ref<{ text: string; value: string }[]>([
  { text: 'CSV', value: ExportOptionsOutputFormatEnum.DEFAULT },
  { text: 'Excel CSV', value: ExportOptionsOutputFormatEnum.EXCEL },
]);

// export types
const selectedExportType = ref<GetExportLinkExportTypeEnum>(
  GetExportLinkExportTypeEnum.EMAILS,
);

const exportTypes = ref<{ text: string; value: string }[]>([
  { text: 'Attachments', value: ExportEntitiesExportTypeEnum.ATTACHMENTS },
  { text: 'Contacts', value: ExportEntitiesExportTypeEnum.CONTACTS },
  { text: 'Inboxes', value: ExportEntitiesExportTypeEnum.INBOXES },
  { text: 'Emails', value: ExportEntitiesExportTypeEnum.EMAILS },
]);
const { exportDownloadLink } = storeToRefs(store3);
const downloadLink = computed(() => {
  return exportDownloadLink.value;
});

const exportData = async () => {
  const payload = {
    exportType: selectedExportType.value,
    exportOptions: {
      outputFormat: selectedOutputFormat.value,
    },
  };
  await loadFetch(() => store3.exportData(payload), store3, loading);
};

const reset = () => {
  store3.exportDownloadLink = null;
};

onMounted(async () => {
  reset();
});
</script>
